class RelatedProductsProgressive extends HTMLElement {
  #items = [];
  #visibleCount = 0;
  #moreButton;
  #mobileQuery = window.matchMedia('(max-width: 749px)');

  connectedCallback() {
    this.#prepareItems();
    if (this.#items.length === 0) return;

    this.#moreButton = this.querySelector('[data-related-products-more]');
    this.#visibleCount = Math.min(this.#initialCount(), this.#items.length);
    this.#render();
    this.#bindEvents();
    this.dataset.ready = 'true';
  }

  #prepareItems() {
    const seenIds = new Set();
    const seenTitles = new Set();
    const currentProductId = this.dataset.currentProductId;
    const max = Number(this.dataset.max) || 20;

    for (const item of this.querySelectorAll('.related-products__item')) {
      const productId = item.dataset.productId;
      const productTitle = item.dataset.productTitle;
      const isDuplicateTitle = productTitle && seenTitles.has(productTitle);

      if (
        !productId ||
        productId === currentProductId ||
        seenIds.has(productId) ||
        isDuplicateTitle ||
        this.#items.length >= max
      ) {
        item.remove();
        continue;
      }

      seenIds.add(productId);
      if (productTitle) seenTitles.add(productTitle);
      item.dataset.position = String(this.#items.length + 1);
      this.#items.push(item);
    }
  }

  #initialCount() {
    return this.#mobileQuery.matches ? 6 : 8;
  }

  #render() {
    this.#items.forEach((item, index) => {
      item.hidden = index >= this.#visibleCount;
    });

    if (!this.#moreButton) return;

    const remaining = this.#items.length - this.#visibleCount;
    this.#moreButton.hidden = remaining <= 0;
    if (remaining > 0) {
      this.#moreButton.textContent = `Show ${Math.min(4, remaining)} more`;
    }
  }

  #bindEvents() {
    this.addEventListener('click', (event) => {
      const moreButton = event.target.closest('[data-related-products-more]');
      if (moreButton) {
        this.#visibleCount = Math.min(this.#visibleCount + 4, this.#items.length);
        this.#render();
        this.#publish('frest_related_products_expand', {
          visibleProducts: this.#visibleCount,
        });
        return;
      }

      const link = event.target.closest('.related-products__item a');
      if (!link) return;
      const item = link.closest('.related-products__item');
      this.#publish('frest_related_product_click', {
        recommendedProductId: item?.dataset.productId,
        position: Number(item?.dataset.position),
        source: item?.dataset.recommendationSource,
      });
    });
  }

  #publish(name, data) {
    try {
      window.Shopify?.analytics?.publish(name, {
        sourceProductId: this.dataset.currentProductId,
        collectionHandle: this.dataset.collectionHandle,
        ...data,
      });
    } catch (error) {
      console.debug(`Analytics event ${name} was not published`, error);
    }
  }
}

if (!customElements.get('related-products-progressive')) {
  customElements.define('related-products-progressive', RelatedProductsProgressive);
}
